const FILE_SIZE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'] as const;
const KILOBYTE = 1024;

export type FileSizeUnitLabel = (typeof FILE_SIZE_UNITS)[number];

export type FileSizeUnit = {
  label: FileSizeUnitLabel;
  factor: number;
};

/**
 * Picks a display unit for a byte range based on its `max`.
 *
 * When max sits exactly on a power-of-1024 boundary (e.g. 1 GB), the next smaller unit is
 * returned so the range stays usable (0–1024 MB rather than just 0–1 GB).
 */
export const getFileSizeUnit = (max: number): FileSizeUnit => {
  if (max <= KILOBYTE) {
    return {label: 'B', factor: 1};
  }

  const rawIndex = Math.floor(Math.log(max - 1) / Math.log(KILOBYTE));
  const index = Math.min(rawIndex, FILE_SIZE_UNITS.length - 1);

  return {label: FILE_SIZE_UNITS[index], factor: Math.pow(KILOBYTE, index)};
};
